<template>
    <div
        v-for="agency in availableAgencies"
        @click="onSelect(agency.uuid)"
        :key="agency.uuid"
    >
        <page-title :title="$t('agencies.joinAgency')"></page-title>
        <p class="mt-4" v-html="$t('agencies.joinAgencyInfo')"></p>
        <div class="flex items-center mt-4 cursor-pointer">
            <ArrowRightIcon
                class="md:mr-2 h-5 w-5 text-white md:text-minplan-darkgreybeige"
            />
            <span class="hover:text-minplan-blue">{{ agency.name }}</span>
        </div>
    </div>

    <div v-if="availableAgencies.length < 1">
        <page-title :title="$t('agencies.noAgency')"></page-title>
        <p class="mt-4" v-html="$t('agencies.noAgencyInfo')"></p>
    </div>
</template>

<script>
import { defineComponent } from "vue";
import MainLayout from "@/Layouts/MainLayout";
import PageTitle from "@/Shared/Components/PageTitle";
import { ArrowRightIcon } from "@heroicons/vue/outline";

export default defineComponent({
    props: ["availableAgencies"],
    layout: MainLayout,
    components: { PageTitle, ArrowRightIcon },
    methods: {
        onSelect(uuid) {
            this.$inertia.post(
                this.route("user.profile.switch-agency", {
                    agency: uuid,
                }),
                {
                    preserveScroll: true,
                }
            );
        },
    },
});
</script>
